var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8China(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#ff3d00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M12,18.574l1.18,3.75H17l-3.09,2.129l1.18,3.633L12,25.84l-3.09,2.246l1.18-3.633L7,22.324h3.82 L12,18.574z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M19.473,16.063l0.355,1.125h1.145l-0.926,0.637l0.355,1.09l-0.93-0.676l-0.926,0.676l0.355-1.09 l-0.93-0.637h1.148L19.473,16.063z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M19.5,29.086l0.355,1.125H21l-0.926,0.637l0.352,1.09L19.5,31.266l-0.926,0.672l0.352-1.09 L18,30.211h1.145L19.5,29.086z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M23.5,20.086l0.355,1.125H25l-0.926,0.637l0.352,1.09L23.5,22.266l-0.926,0.672l0.352-1.09 L22,21.211h1.145L23.5,20.086z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M23.5,25.086l0.355,1.125H25l-0.926,0.637l0.352,1.09L23.5,27.266l-0.926,0.672l0.352-1.09 L22,26.211h1.145L23.5,25.086z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8China);
export default __webpack_public_path__ + "static/media/icons8-china.441f5797cec9b4ca228e4d5e82141518.svg";
export { ForwardRef as ReactComponent };